import fetchDemographicData from '#/repository/fetch-housing-data';
import {useQuery} from '@tanstack/react-query';

export const useDemographics = (symbol: string) =>
  useQuery({
    queryKey: ['demographics', symbol],
    queryFn: () => fetchDemographicData(symbol),
  });
